/* Mati Atelier — theme.js (vanilla, no dependencies) */
(() => {
  'use strict';
  const T = window.theme || {};
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const debounce = (fn, ms) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }; };

  /* ---------- money ---------- */
  function formatMoney(cents) {
    const fmt = T.money || '${{amount}}';
    const n = Number(cents) / 100;
    const withSep = (num, dec, th, ds) => {
      const [i, d] = num.toFixed(dec).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, th) + (d ? ds + d : '');
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      switch (k) {
        case 'amount_no_decimals': return withSep(n, 0, ',', '.');
        case 'amount_with_comma_separator': return withSep(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withSep(n, 0, '.', ',');
        default: return withSep(n, 2, ',', '.');
      }
    }).replace(/<[^>]*>/g, '');
  }

  /* ---------- toast ---------- */
  const toast = (msg) => {
    const el = $('[data-toast]'); if (!el) return;
    el.textContent = msg; el.hidden = false;
    clearTimeout(el._t); el._t = setTimeout(() => { el.hidden = true; }, 2800);
  };

  /* ---------- drawers ---------- */
  const Drawers = {
    last: null,
    open(id) {
      const d = document.getElementById(id); if (!d) return;
      this.last = document.activeElement;
      $$('[data-drawer][aria-hidden="false"]').forEach(x => { if (x !== d) this.close(x, false); });
      d.setAttribute('aria-hidden', 'false');
      document.body.classList.add('has-drawer');
      const f = d.querySelector('[data-search-input]') || d.querySelector('input:not([type=hidden]), button, a[href]');
      if (f) setTimeout(() => f.focus({ preventScroll: true }), 60);
    },
    close(d, restore = true) {
      if (!d) return;
      d.setAttribute('aria-hidden', 'true');
      if (!$('[data-drawer][aria-hidden="false"]')) document.body.classList.remove('has-drawer');
      if (restore && this.last && this.last.focus) this.last.focus({ preventScroll: true });
    },
    init() {
      document.addEventListener('click', (e) => {
        const o = e.target.closest('[data-open]');
        if (o) {
          const id = o.getAttribute('data-open');
          const target = document.getElementById(id);
          // on desktop the filter panel is always visible: nothing to open
          if (target && target.classList.contains('drawer--desktop-static') && matchMedia('(min-width: 990px)').matches) return;
          if (target) { e.preventDefault(); this.open(id); }
          return;
        }
        const c = e.target.closest('[data-close]');
        if (c) { e.preventDefault(); this.close(c.closest('[data-drawer]')); }
      });
      document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') return;
        const d = $$('[data-drawer][aria-hidden="false"]').pop();
        if (d) this.close(d);
        $$('details[data-mega][open]').forEach(m => m.removeAttribute('open'));
      });
    }
  };

  /* ---------- header ---------- */
  function initHeader() {
    const h = $('[data-header]');
    if (h) {
      const onScroll = () => h.classList.toggle('is-scrolled', window.scrollY > 4);
      addEventListener('scroll', onScroll, { passive: true }); onScroll();
    }
    const megas = $$('details[data-mega]');
    megas.forEach(m => m.addEventListener('toggle', () => {
      if (m.open) megas.forEach(o => { if (o !== m) o.removeAttribute('open'); });
    }));
    document.addEventListener('click', (e) => {
      if (!e.target.closest('details[data-mega]')) megas.forEach(m => m.removeAttribute('open'));
    });
    const ann = $('[data-announce]');
    if (ann) {
      const msgs = $$('.announce__msg', ann);
      if (msgs.length > 1 && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
        let i = 0;
        setInterval(() => { msgs[i].classList.remove('is-active'); i = (i + 1) % msgs.length; msgs[i].classList.add('is-active'); }, 4500);
      }
    }
  }

  /* ---------- cart ---------- */
  const Cart = {
    setCount(n) {
      $$('[data-cart-count]').forEach(el => { el.textContent = n; el.hidden = !n; });
    },
    renderDrawer(html) {
      const wrap = document.getElementById('shopify-section-cart-drawer');
      if (!wrap || !html) return;
      const wasOpen = $('#cart-drawer')?.getAttribute('aria-hidden') === 'false';
      const tmp = document.createElement('div'); tmp.innerHTML = html;
      const fresh = tmp.querySelector('#shopify-section-cart-drawer') || tmp;
      wrap.innerHTML = fresh.innerHTML;
      if (wasOpen) $('#cart-drawer').setAttribute('aria-hidden', 'false');
    },
    async add(form, btn) {
      const fd = new FormData(form);
      fd.append('sections', 'cart-drawer');
      fd.append('sections_url', location.pathname);
      btn && (btn.disabled = true, btn.classList.add('is-busy'));
      try {
        const r = await fetch(T.routes.cartAdd + '.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
        const data = await r.json();
        if (!r.ok) throw new Error(data.description || data.message || T.strings.error);
        this.renderDrawer(data.sections && data.sections['cart-drawer']);
        const c = await (await fetch(T.routes.cart + '.js')).json();
        this.setCount(c.item_count);
        Drawers.open('cart-drawer');
      } catch (err) {
        toast(err.message || T.strings.error);
      } finally {
        btn && (btn.disabled = false, btn.classList.remove('is-busy'));
      }
    },
    async change(key, qty, line) {
      line && line.classList.add('is-busy');
      try {
        const r = await fetch(T.routes.cartChange + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty, sections: ['cart-drawer'], sections_url: location.pathname })
        });
        const data = await r.json();
        if (!r.ok) throw new Error(data.description || T.strings.error);
        if (document.body.classList.contains('t-cart')) { location.reload(); return; }
        this.renderDrawer(data.sections && data.sections['cart-drawer']);
        this.setCount(data.item_count);
      } catch (err) {
        toast(err.message || T.strings.error);
        line && line.classList.remove('is-busy');
      }
    },
    init() {
      document.addEventListener('submit', (e) => {
        const form = e.target.closest('form[data-product-form]');
        if (!form) return;
        e.preventDefault();
        this.add(form, form.querySelector('[data-add]'));
      });
      document.addEventListener('click', (e) => {
        const b = e.target.closest('[data-line] [data-qty]');
        if (!b) return;
        const line = b.closest('[data-line]');
        this.change(line.dataset.key, parseInt(b.dataset.qty, 10), line);
      });
    }
  };

  /* ---------- product ---------- */
  function initProduct(root) {
    const form = $('form[data-product-form]', root); if (!form) return;
    const variants = JSON.parse($('[data-variants]', form)?.textContent || '[]');
    const fieldsets = $$('fieldset[data-option-index]', form);
    const idInput = $('[data-variant-id]', form);
    const addBtn = $('[data-add]', form);
    const addLabel = $('[data-add-label]', form);
    const priceNow = $('[data-price-now]', root);
    const priceWas = $('[data-price-was]', root);
    const priceBadge = $('[data-price-badge]', root);
    const priceBox = $('[data-price]', root);
    const youSave = $('[data-you-save]', root);
    const stickyPrice = $('[data-sticky-price]');
    const stickyBtn = $('[data-sticky-add]');

    const selected = () => fieldsets.map(fs => ($('input:checked', fs) || {}).value);

    function markAvailability(sel) {
      fieldsets.forEach((fs, i) => {
        $$('input[data-option-input]', fs).forEach(inp => {
          const ok = variants.some(v => v.available && v.options[i] === inp.value &&
            v.options.every((o, j) => j === i || o === sel[j]));
          const label = form.querySelector(`label[for="${inp.id}"]`);
          label && label.classList.toggle('is-na', !ok);
        });
      });
    }

    function update(changedIdx) {
      let sel = selected();
      let v = variants.find(x => x.options.every((o, i) => o === sel[i]));
      if (!v && changedIdx != null) {
        // combination doesn't exist: keep the value just picked, move the others to a real variant
        const cands = variants.filter(x => x.options[changedIdx] === sel[changedIdx]);
        v = cands.find(x => x.available) || cands[0];
        if (v) {
          fieldsets.forEach((fs, i) => { const inp = $$('input', fs).find(n => n.value === v.options[i]); if (inp) inp.checked = true; });
          sel = selected();
        }
      }
      fieldsets.forEach((fs, i) => { const l = $('[data-option-label]', fs); if (l) l.textContent = sel[i] || ''; });
      markAvailability(sel);
      if (!v) return;
      idInput.value = v.id;
      const sale = v.compare > v.price;
      if (priceNow) priceNow.textContent = formatMoney(v.price);
      if (priceWas) { priceWas.textContent = sale ? formatMoney(v.compare) : ''; priceWas.hidden = !sale; }
      if (priceBadge) { priceBadge.textContent = sale ? '−' + Math.round((v.compare - v.price) * 100 / v.compare) + '%' : ''; priceBadge.hidden = !sale; }
      if (priceBox) priceBox.classList.toggle('price--sale', sale);
      if (youSave) {
        youSave.hidden = !sale;
        if (sale) youSave.textContent = 'You save ' + formatMoney(v.compare - v.price);
      }
      if (addBtn) { addBtn.disabled = !v.available; }
      if (addLabel) addLabel.textContent = v.available ? T.strings.addToBag : T.strings.soldOut;
      if (stickyPrice) stickyPrice.textContent = formatMoney(v.price);
      if (stickyBtn) stickyBtn.disabled = !v.available;
      if (changedIdx != null) {
        const url = new URL(location.href); url.searchParams.set('variant', v.id);
        history.replaceState(null, '', url);
        if (v.media) Gallery.goTo(root, v.media);
      }
    }

    form.addEventListener('change', (e) => {
      const fs = e.target.closest('fieldset[data-option-index]');
      if (fs) update(parseInt(fs.dataset.optionIndex, 10));
    });
    form.addEventListener('click', (e) => {
      const s = e.target.closest('[data-step]'); if (!s) return;
      const q = $('input[name=quantity]', form);
      q.value = Math.max(1, (parseInt(q.value, 10) || 1) + parseInt(s.dataset.step, 10));
    });
    update(null);

    // sticky add to bag (mobile)
    const bar = $('[data-sticky-buy]');
    if (bar && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => {
        bar.hidden = en.isIntersecting || en.boundingClientRect.top > 0;
      }).observe(addBtn);
      stickyBtn && stickyBtn.addEventListener('click', () => (form.requestSubmit ? form.requestSubmit(addBtn) : addBtn.click()));
    }
  }

  const Gallery = {
    init(root) {
      const track = $('[data-gallery-track]', root); if (!track) return;
      const slides = $$('.gallery__slide', track);
      const dots = $$('.gallery__dot', root);
      const thumbs = $$('[data-thumb]', root);
      const setActive = (i) => {
        dots.forEach((d, j) => d.classList.toggle('is-active', j === i));
        thumbs.forEach((t, j) => t.classList.toggle('is-active', j === i));
      };
      track.addEventListener('scroll', debounce(() => {
        const i = Math.round(track.scrollLeft / track.clientWidth); setActive(i);
      }, 60), { passive: true });
      thumbs.forEach((t, i) => t.addEventListener('click', () => {
        track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' }); setActive(i);
      }));
    },
    goTo(root, mediaId) {
      const track = $('[data-gallery-track]', root);
      const slide = track && track.querySelector(`[data-media-id="${mediaId}"]`);
      if (slide) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }
  };

  /* ---------- predictive search ---------- */
  function initSearch() {
    const box = $('[data-search]'); if (!box) return;
    const input = $('[data-search-input]', box);
    const out = $('[data-search-results]', box);
    const initial = out.innerHTML;
    const run = debounce(async () => {
      const q = input.value.trim();
      if (q.length < 2) { out.innerHTML = initial; return; }
      try {
        const url = `${T.routes.predictive}.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last`;
        const data = await (await fetch(url)).json();
        const items = (data.resources && data.resources.results && data.resources.results.products) || [];
        if (!items.length) { out.innerHTML = `<p class="muted">${T.strings.noResults}</p>`; return; }
        const esc = (s) => String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
        out.innerHTML = '<div class="suggest">' + items.map(p => {
          const img = p.featured_image && p.featured_image.url ? p.featured_image.url : '';
          const price = p.price ? formatMoney(Math.round(parseFloat(p.price) * 100)) : '';
          return `<a class="suggest__item" href="${p.url}">${img ? `<img src="${img}${img.includes('?') ? '&' : '?'}width=300" alt="" loading="lazy" width="300" height="300">` : ''}<span>${esc(p.title)}</span><span class="suggest__price">${price}</span></a>`;
        }).join('') + `</div><p style="margin-top:18px"><a class="link-arrow" href="${T.routes.search}?q=${encodeURIComponent(q)}&options[prefix]=last">View all results →</a></p>`;
      } catch (e) { /* network hiccup: keep last results */ }
    }, 220);
    input && input.addEventListener('input', run);
  }

  /* ---------- collection: filters, sort, load more ---------- */
  function initCollection() {
    const root = $('[data-collection]'); if (!root) return;

    async function load(url, push = true) {
      const results = $('[data-results]', root) || root;
      results.classList.add('is-loading');
      try {
        const html = await (await fetch(url, { headers: { 'X-Requested-With': 'fetch' } })).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-results]');
        const drawerOpen = $('#facets-drawer')?.getAttribute('aria-hidden') === 'false';
        if (fresh && $('[data-results]', root)) {
          $('[data-results]', root).replaceWith(fresh);
          if (drawerOpen) $('#facets-drawer')?.setAttribute('aria-hidden', 'false');
        } else { location.href = url; return; }
        if (push) history.pushState({ url }, '', url);
      } catch (e) { location.href = url; }
    }

    const facetUrl = (form) => {
      const params = new URLSearchParams();
      new FormData(form).forEach((v, k) => { if (v !== '') params.append(k, v); });
      const sort = $('[data-sort]', root);
      if (sort && sort.value) params.set('sort_by', sort.value);
      return `${form.getAttribute('action') || location.pathname}?${params.toString()}`;
    };

    root.addEventListener('change', (e) => {
      const form = e.target.closest('[data-facets]');
      if (form && e.target.type === 'checkbox') load(facetUrl(form));
      if (e.target.matches('[data-sort]')) {
        const f = $('[data-facets]', root);
        if (f) load(facetUrl(f));
        else { const u = new URL(location.href); u.searchParams.set('sort_by', e.target.value); load(u.toString()); }
      }
    });
    root.addEventListener('input', debounce((e) => {
      const form = e.target.closest('[data-facets]');
      if (form && e.target.type === 'number') load(facetUrl(form));
    }, 700));
    root.addEventListener('click', async (e) => {
      const a = e.target.closest('.active-filters a, [data-more-link]');
      if (!a) return;
      e.preventDefault();
      if (a.matches('[data-more-link]')) {
        const more = a.closest('[data-more]');
        a.classList.add('is-busy'); a.setAttribute('aria-busy', 'true');
        try {
          const html = await (await fetch(a.href)).text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const grid = $('[data-grid]', root);
          doc.querySelectorAll('[data-grid] > *').forEach(n => grid.appendChild(document.importNode(n, true)));
          const nextMore = doc.querySelector('[data-more]');
          nextMore ? more.replaceWith(document.importNode(nextMore, true)) : more.remove();
        } catch (err) { location.href = a.href; }
      } else {
        load(a.href);
      }
    });
    addEventListener('popstate', () => load(location.href, false));
  }

  /* ---------- recommendations ---------- */
  function initRecommendations() {
    $$('[data-recommendations]').forEach(async (el) => {
      if (el.querySelector('.card')) return;
      try {
        const html = await (await fetch(el.dataset.url)).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
      } catch (e) { /* optional block */ }
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    Drawers.init();
    initHeader();
    Cart.init();
    $$('[data-product]').forEach(root => { Gallery.init(root); initProduct(root); });
    initSearch();
    initCollection();
    initRecommendations();
  });

  T.formatMoney = formatMoney;
  window.theme = T;
})();
